import { render, staticRenderFns } from "./auth-data.vue?vue&type=template&id=582cebe1&scoped=true"
import script from "./auth-data.vue?vue&type=script&lang=js"
export * from "./auth-data.vue?vue&type=script&lang=js"
import style0 from "./auth-data.vue?vue&type=style&index=0&id=582cebe1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582cebe1",
  null
  
)

export default component.exports